<template>
  <div class="transaction">
    <Header :mainHeader="true" />

    <section id="transaction-products" style="padding: 10px 0px !important">
      <div class="containers">
        <h5 class="fw-bold">
          Sales Invoices
          <a
            class="btn btn-primary btn-sm"
            style="float: right"
            href="/sales/make"
            >Make a Sale</a
          >
        </h5>

        <div class="table-container">
          <table class="table table-hover" id="salesTable" style="width: 100%">
            <thead>
              <tr>
                <th>No</th>
                <th>Invoice No.</th>
                <th>Sales Date</th>
                <th>Items</th>
                <th>Amount</th>
                <th>Tax</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody v-if="sales">
              <tr v-for="(sale, index) in sales" v-bind:key="sale.id">
                <td>{{ index + 1 }}</td>
                <td>{{ sale.invcNo }}</td>
                <td>{{ formatDateOnly(sale.salesDt) }}</td>
                <td>{{ sale.totItemCnt }}</td>
                <td>KES {{ sale.totAmt }}</td>
                <td>KES {{ sale.totTaxAmt }}</td>
                <td>
                  <button
                    class="btn btn-primary btn-sm"
                    style="margin-right: 10px"
                    @click="openModal(sale)"
                  >
                    Credit Sale
                  </button>
                  <button
                    class="btn btn-default btn-sm"
                    style="margin-right: 10px; border: 1px solid #000"
                    @click="openModalSale(sale)"
                  >
                    Sale Details
                  </button>
                  <button
                    class="btn btn-sm"
                    style="background-color: #e6f0ff"
                    @click="convertToPDF(sale.invcNo)"
                  >
                    Receipt <i class="fa fa-download"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <p v-else>No Sale found</p>
          </table>
        </div>
      </div>
      <div
        style="
          max-width: 80mm;
          border: 1px solid #000;
          position: absolute;
          left: -9999px;
        "
      >
        <div ref="convert" v-if="sales">
          <SalesReceipt />
        </div>
      </div>
      <!-- <div
        style="
          width: 210mm !important;
          height: 297mm !important;
          border: 1px solid #000;
          position: absolute;
          left: -9999px;
        "
      >
        <div ref="convert" v-if="sales">
          <A4SalesReceipt />
        </div>
      </div> -->
    </section>

    <div v-show="isVisible" class="modal">
      <div class="modal-content">
        <h3>
          Make a credit note of this Sale Invoice Number {{ sale.invcNo }}
        </h3>
        <span
          class="close"
          style="
            position: absolute;
            width: fit-content;
            right: 0;
            margin-right: 20px;
          "
          @click="closeModal"
          >&times;</span
        >
        <div class="row">
          <p>Update Customer Details</p>
          <div class="col-md-3">
            <label for="">Customer Pin</label>
            <input type="text" v-model="customerPin" class="form-control" />
          </div>
          <div class="col-md-3">
            <label for="">Customer Name</label>
            <input type="text" v-model="customerName" class="form-control" />
          </div>
          <div class="col-md-3">
            <label for="">Customer Email</label>
            <input type="text" v-model="customerEmail" class="form-control" />
          </div>
          <div class="col-md-3">
            <label for="">Customer Mobile</label>
            <input type="text" v-model="customerMobile" class="form-control" />
          </div>
          <hr />
          <p>Credit Note Details</p>
          <div class="col-md-5">
            <label for="">Select Credit Note Reason</label>
            <select
              v-model="status"
              class="form-control"
              style="width: 98%"
              v-if="codes[11]"
            >
              <option
                v-for="objItem in codes[11].dtlList"
                v-bind:key="objItem.id"
                :value="objItem.cd"
              >
                {{ objItem.cdNm }}
              </option>
            </select>
            <p v-else>Wait. Loading ...</p>
          </div>
          <div class="col-md-7">
            <label for="">Remarks</label>
            <input type="text" v-model="remarks" class="form-control" />
          </div>
        </div>
        <table class="table table-bordered" style="margin-top: 20px">
          <thead>
            <th>Item Name</th>
            <th>Item Code</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Discount</th>
            <th>Total</th>
            <th>Action</th>
          </thead>
          <tbody>
            <tr v-for="saleItem in sale.items" v-bind:key="saleItem.itemSeq">
              <td>{{ saleItem.itemNm }}</td>
              <td>{{ saleItem.itemCd }}</td>
              <td>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  v-model="saleItem.qty"
                />
              </td>
              <td>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  v-model="saleItem.prc"
                />
              </td>
              <td>KES {{ formatToMoney(saleItem.dcAmt) }}</td>
              <td>KES {{ formatToMoney(saleItem.totAmt) }}</td>
              <td>
                <button
                  v-if="saleItem.updatedAt != 'done'"
                  class="btn btn-primary btn-sm"
                  @click="creditItem(saleItem)"
                >
                  Credit
                </button>
                <button v-else class="btn btn-sm btn-warning">Done</button>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          class="btn-style"
          style="float: right; margin: 20px"
          @click="creditSale"
          v-if="isClickCredit"
        >
          Make Credit Note
        </button>
      </div>
    </div>

    <div v-show="isVisibleSale" class="modal">
      <div class="modal-content">
        <h3>Sale Invoice Number {{ sale.invcNo }}</h3>
        <span
          class="close"
          style="
            position: absolute;
            width: fit-content;
            right: 0;
            margin-right: 20px;
          "
          @click="closeModalSale"
          >&times;</span
        >
        <div class="row">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th>Date of Transaction</th>
                <td>{{ formatDate(selectedSale.createdAt) }}</td>
                <th>Sale Total Amount</th>
                <td>KES {{ formatToMoney(selectedSale.totAmt) }}</td>
              </tr>
              <tr>
                <th>Sale Total Tax</th>
                <td>KES {{ formatToMoney(selectedSale.totTaxAmt) }}</td>
                <th>Customer Details</th>
                <td>{{ selectedSale.custTin }} - {{ selectedSale.custNm }}</td>
              </tr>
              <tr>
                <th>eTims Link:</th>
                <td>
                  <a
                    target="_blank"
                    :href="`https://etims.kra.go.ke/common/link/etims/receipt/indexEtimsReceiptData?Data=${
                      selectedSale?.Business?.pin +
                      '' +
                      selectedSale?.Business?.bhfId +
                      '' +
                      selectedSale?.rcptSign
                    }`"
                    class="btn btn-default btn-sm"
                    style="border: 1px solid #000"
                    >Open
                  </a>
                </td>
                <th>Sale Items</th>
                <td>count: {{ selectedSale.totItemCnt }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <th>Sale Items</th>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>No.</td>
                <td>Item Code</td>
                <td>Item Name</td>
                <td>Quantity</td>
                <td>Price</td>
                <td>Disc</td>
                <td>Total</td>
              </tr>
              <tr
                v-for="(item, index) in selectedSale.items"
                v-bind:key="item.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.itemCd }}</td>
                <td>{{ item.itemNm }}</td>
                <td>{{ item.qty }}</td>
                <td>{{ item.prc }}</td>
                <td>{{ item.dcAmt }}</td>
                <td>{{ item.totAmt }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header";
import SalesReceipt from "../../components/SalesReceipt.vue";
// import A4SalesReceipt from "@/components/A4SalesReceipt.vue";
import Swal from "sweetalert2";
import { toRaw } from "vue";
import "datatables.net-vue3";
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from "jquery";
//import 'jszip';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.print.js";
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import { useMakeSaleStore } from "@/stores/SaleStore";

export default {
  name: "SalePage",
  components: {
    Header,
    SalesReceipt,
    // A4SalesReceipt,
  },
  data() {
    return {
      token: JSON.parse(localStorage.getItem("access_token")),
      sales: [],
      processedData: [],
      isVisible: false,
      isClickCredit: true,
      isVisibleSale: false,
      isVisibleReceipt: false,
      codes: [],
      customerPin: "",
      selectedSale: {},
      customerName: "",
      customerEmail: "",
      customerMobile: "",
      remarks: "",
      status: "",
      reason: "",
      sale: {},
      taxblAmtA: 0.0,
      taxblAmtB: 0.0,
      taxblAmtC: 0.0,
      taxblAmtD: 0.0,
      taxblAmtE: 0.0,
      taxRtA: 0,
      taxRtB: 16,
      taxRtC: 0,
      taxRtD: 0,
      taxRtE: 8,
      taxAmtA: 0,
      taxAmtB: 0,
      taxAmtC: 0,
      taxAmtD: 0,
      taxAmtE: 0,
      totTaxblAmt: 0.0,
      totTaxAmt: 0.0,
      totAmt: 0.0,
      creditItems: [],
      unapprovedPos: 0,
    };
  },
  methods: {
    openModal(obj) {
      this.isVisible = true;
      this.sale = toRaw(obj);
      this.customerPin = this.sale.receipt?.custTin;
      this.customerName = this.sale.receipt?.trdeNm;
      this.customerEmail = this.sale.receipt?.custEmail;
      this.customerMobile = this.sale.receipt?.custMblNo;
    },
    openModalSale(obj) {
      this.isVisibleSale = true;
      this.selectedSale = obj;
    },
    formatDate(rawDate) {
      if (rawDate) {
        const dateNo = new Date(rawDate);
        var minutes = 0;
        if (dateNo.getMinutes() < 10) {
          minutes = "0" + dateNo.getMinutes();
        } else {
          minutes = dateNo.getMinutes();
        }
        var hours = 0;
        if (dateNo.getHours() < 10) {
          hours = "0" + dateNo.getHours();
        } else {
          hours = dateNo.getHours();
        }
        return (
          dateNo.getDate() +
          "/" +
          (dateNo.getMonth() + 1) +
          "/" +
          dateNo.getFullYear() +
          " - " +
          hours +
          ":" +
          minutes
        );
      } else {
        return "";
      }
    },
    formatDateOnly(date) {
      // changing the date format from yyyymmdd to dd-mm-yyyy

      if (!date) return "";

      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);

      const formattedDate = new Date(`${year}-${month}-${day}`);

      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      return formattedDate
        .toLocaleDateString("en-GB", options)
        .replace(/\//g, "-");
    },
    formatToMoney(value) {
      const formattedValue = Number(value).toFixed(2);
      return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeModal() {
      this.isVisible = false;
    },
    closeModalSale() {
      this.isVisibleSale = false;
    },
    creditItem(saleItemObj) {
      let objItem = toRaw(saleItemObj);
      this.creditItems = this.creditItems.filter(
        (obj) => obj.itemSeq !== objItem.itemSeq
      );
      var taxitemAmt = 0;
      var taxblAmt = 0;
      var itemSubTotal = this.roundToTwo(objItem.qty * objItem.prc);
      if (objItem.taxTyCd == "B") {
        taxblAmt = this.roundToTwo(itemSubTotal / 1.16);
        taxitemAmt = this.roundToTwo(itemSubTotal - taxblAmt);
        this.taxblAmtB = this.roundToTwo(this.taxblAmtB + taxblAmt);
        this.taxAmtB = this.roundToTwo(this.taxAmtB + taxitemAmt);
      } else if (objItem.taxTyCd == "E") {
        taxblAmt = this.roundToTwo(itemSubTotal / 1.08);
        taxitemAmt = this.roundToTwo(itemSubTotal - taxblAmt);
        this.taxblAmtE = this.roundToTwo(this.taxblAmtE + taxblAmt);
        this.taxAmtE = this.roundToTwo(this.taxAmtE + taxitemAmt);
      } else {
        taxblAmt = itemSubTotal;
        taxitemAmt = 0;
        if (objItem.taxTyCd == "A") {
          this.taxblAmtA = this.roundToTwo(this.taxblAmtA + itemSubTotal);
        } else if (objItem.taxTyCd == "C") {
          this.taxblAmtC = this.roundToTwo(this.taxblAmtC + itemSubTotal);
        } else if (objItem.taxTyCd == "D") {
          this.taxblAmtD = this.roundToTwo(this.taxblAmtD + itemSubTotal);
        }
      }

      this.totTaxblAmt = this.roundToTwo(this.totTaxblAmt + taxblAmt);
      this.totTaxAmt = this.roundToTwo(this.totTaxAmt + taxitemAmt);
      this.totAmt = this.roundToTwo(this.totAmt + itemSubTotal);

      saleItemObj.updatedAt = "done";
      const obj = {
        ...objItem,
        dcRt: parseFloat(objItem.dcRt),
        dcAmt: parseFloat(objItem.dcAmt),
        pkg: parseFloat(objItem.qty),
        qty: parseFloat(objItem.qty),
        prc: parseFloat(objItem.prc),
        splyAmt: parseFloat(itemSubTotal),
        taxblAmt: parseFloat(taxblAmt),
        taxAmt: parseFloat(taxitemAmt),
        totAmt: parseFloat(itemSubTotal),
      };
      this.creditItems.push(obj);
    },
    async creditSale() {
      this.isClickCredit = false;
      const dateTimeNow = this.getCurrentDateTimeFormatted();
      const dateOnlyNow = this.getCurrentDateFormatted();
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
        body: JSON.stringify({
          cfmDt: dateTimeNow,
          custEmail: this.customerEmail,
          custId: this.sale.receipt?.customerId,
          custNm: this.customerName,
          custTel: this.customerMobile,
          custTin: this.customerPin,
          custType: "NEW",
          invcNo: "1",
          itemList: this.creditItems,
          modrId: "Admin",
          modrNm: "Admin",
          orgInvcNo: this.sale.invcNo,
          pmtTyCd: this.sale.pmtTyCd,
          prchrAcptcYn: "N",
          rcptTyCd: "R",
          regrId: "Admin",
          regrNm: "Admin",
          remark: this.remark,
          salesDt: dateOnlyNow,
          salesSttsCd: "02",
          salesTyCd: "N",
          stockRlsDt: dateTimeNow,
          taxAmtA: this.taxAmtA,
          taxAmtB: this.taxAmtB,
          taxAmtC: this.taxAmtC,
          taxAmtD: this.taxAmtD,
          taxAmtE: this.taxAmtE,
          taxRtA: 0,
          taxRtB: 16,
          taxRtC: 0,
          taxRtD: 0,
          taxRtE: 8,
          taxblAmtA: this.taxblAmtA,
          taxblAmtB: this.taxblAmtB,
          taxblAmtC: this.taxblAmtC,
          taxblAmtD: this.taxblAmtD,
          taxblAmtE: this.taxblAmtE,
          totAmt: this.totAmt,
          totItemCnt: this.creditItems.length,
          totTaxAmt: this.totTaxAmt,
          totTaxblAmt: this.totTaxblAmt,
          trdInvcNo: "1",
        }),
      };
      const res = await fetch(
        process.env.VUE_APP_URL + "/credit",
        requestOptions
      );
      const data = await res.json();
      if (data.status == true) {
        Swal.fire({
          icon: "success",
          title: "Credit made successfully",
          text: data.message,
        });
        this.isVisible = false;
      } else {
        Swal.fire({
          icon: "error",
          title: "Credit not found",
          text: data.message,
        });
        this.isClickCredit = true;
      }
    },
    convertStringToNumber(stringValue) {
      return parseFloat(stringValue);
    },
    roundToTwo(num) {
      var number = parseFloat(num);
      if (isNaN(number)) {
        return num;
      }
      return this.convertStringToNumber(number.toFixed(2));
    },

    async getSales() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      const res = await fetch(
        process.env.VUE_APP_URL + "/sales",
        requestOptions
      );
      const data = await res.json();
      if (data.status == true) {
        this.sales = data.sales;
        this.processedData = this.preprocessData(this.sales);
        // this.initializeDataTable();
        const store = useMakeSaleStore();
        store.setSaleDetails(data.sales);
      } else {
        Swal.fire({
          icon: "error",
          title: "Sale not found",
          text: data.message,
        });
      }
    },

    preprocessData(rawData) {
      return rawData?.map((item) => {
        return {
          indexNo: "1",
          invoiceNo: item.invcNo,
          salesDt: item.salesDt,
          items: item.totItemCnt,
          amount: item.totAmt,
          tax: item.totTaxAmt,
        };
      });
    },

    initializeDataTable() {
      try {
        this.dataTable = $(this.$el)
          .find("#salesTable")
          .DataTable({
            responsive: true,
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: '<"datatable-buttons"B><"datatable-search"f>tip',
            buttons: [
              {
                extend: "colvis",
                text: "Column Visibility",
                className: "btn-grey",
              },
              {
                extend: "pageLength",
                text: "Page Length",
                className: "btn-grey",
              },
              {
                extend: "csv",
                text: "Export CSV",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "pdfHtml5",
                text: "Export PDF",
                orientation: "landscape",
                className: "btn-grey",
                exportOptions: {
                  columns: ":visible",
                },
                customize: this.customizePDF,
              },
            ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: "invoiceNo" },
              { data: "salesDt" },
              { data: "items" },
              { data: "amount" },
              { data: "tax" },
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
      } catch (error) {
        console.log({ error });
      }
    },

    customizePDF(doc) {
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0;
      doc.content[1].fillColor = "#f2f2f2";

      (doc.header = () => {
        return {
          columns: [
            {
              width: "*",
              columns: [
                /* {
                            image: logoBase64,
                            width: 150, // Adjust the width as needed
                        },*/
                {
                  //   text: "Pavicon (K) Limited",
                  text: "Taxpoint",
                  alignment: "left",
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  //   color: "#FFA500", // Orange color
                  color: "#000",
                  bold: true,
                  fontSize: 14,
                },
              ],
            },
            {
              width: "*",
              stack: [
                {
                  text: "Products List",
                  alignment: "right",
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: "#4448B3",
                },
                {
                  alignment: "right",
                  margin: [300, 0, 0, 0],
                  width: "*",
                  columns: [
                    {
                      width: "auto",
                      text: "Date:",
                      alignment: "right",
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: "auto",
                      text: `${this.formatDate(new Date(), "true")}`,
                      alignment: "right",
                      margin: [0, 0, 50, 0],
                      fontSize: 9,
                    },
                  ],
                },
              ],
            },
          ],
          fillColor: "#000000",
        };
      }),
        (doc.footer = (currentPage, pageCount) => {
          return {
            columns: [
              { width: "*", text: "www.pavicongroup.co.ke", alignment: "left" },
              {
                width: "*",
                text: "contact@pavicongroup.co.ke",
                alignment: "center",
              },
              {
                width: "*",
                text: `Page ${currentPage} of ${pageCount}`,
                alignment: "center",
              },
              {
                width: "*",
                text: `Printed on ${this.formatDate(new Date(), "true")}`,
                alignment: "right",
              },
            ],
            margin: [40, 10, 40, 10], // Margin for the whole footer
            fillColor: "black",
          };
        });

      doc.styles.title = {
        color: "#4448B3",
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },

    async getCodes() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      const res = await fetch(
        process.env.VUE_APP_URL + "/items/pullcodes",
        requestOptions
      );
      const data = await res.json();
      this.codes = data.kraResult?.clsList;
    },
    getCurrentDateFormatted() {
      const now = new Date();
      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");

      return `${year}${month}${day}`;
    },
    getCurrentDateTimeFormatted() {
      const now = new Date();
      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");

      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },
    async convertToPDF(id) {
      const store = useMakeSaleStore();
      store.fetchSaleId(id);

      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        today.getDate().toString().padStart(2, "0");

      const receiptName = date + "_" + id + ".pdf";

      const element = await this.$refs.convert;
      const canvas = await html2canvas(element, { scale: 5 });

      const pdfDoc = await PDFDocument.create();
      const page = pdfDoc.addPage([canvas.width, canvas.height]);
      const { width, height } = page.getSize();

      const imgData = canvas.toDataURL("image/png");
      const img = await pdfDoc.embedPng(imgData);
      const imgDims = img.scaleToFit(width, height);

      page.drawImage(img, {
        x: 0,
        y: page.getHeight() - imgDims.height,
      });

      const pdfBytes = await pdfDoc.save();
      this.download(pdfBytes, receiptName, "application/pdf");
    },
    download(blob, filename, mimeType) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: mimeType })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
  },
  mounted() {
    this.getSales();
    this.getCodes();
  },
  watch: {
    "sale.items": {
      handler(newItems) {
        newItems.forEach((item, index) => {
          let priceChange = item.prc * item.qty;
          this.sale.items[index].totAmt = priceChange;
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>
